import { FC } from 'react'
import { ConfirmationModal } from 'featureSliced/features/ConfirmationModal'
import { useTranslations } from '../../featureSliced/shared/hooks/useTranslations'

type ReceiptErrorProps = {
  onCloseModal: (orderGuid?: string) => void
}

export const ReceiptError: FC<ReceiptErrorProps> = ({ onCloseModal }) => {
  const t = useTranslations()
  return (
    <ConfirmationModal
      text={t('receipt.receiptError')}
      onConfirm={onCloseModal}
    />
  )
}
